export const defaultColumns = [
  { label: 'Produto', value: 'name' },
  { label: 'Quantidade', value: 'quantity' },
  { label: 'Valor Unt', value: 'unitValue' },
  { label: 'Valor total', value: 'totalValue' },
]
